// extracted by mini-css-extract-plugin
module.exports = {"tooltip-content":"_2FMPW","tooltipContent":"_2FMPW"};